import React from "react";
import { Routes, Route } from "react-router-dom";
import SportsNavBar from "../../components/common/SportsNavBar";

import Cricket from "./Cricket";
import NBA from "./NBA";
import NFL from "./NFL";
import Soccer from "./Soccer";
import Golf from "./Golf";
import MLB from "./MLB";
import Tennis from "./Tennis";
import Hockey from "./Hockey";
import NHL from "./NHL";
import Chess from "./Chess";
import { Helmet } from "react-helmet";
import Olympics from "./Olympics";

function Sports() {
  return (
    <div>
      <Helmet>
        <title>
          Sports News: IPL 2026, Live Scores & Cricket Updates | BharatAbroad
        </title>
        <meta
          name="description"
          content="Get the latest sports news in India with IPL 2026 updates, live cricket scores, match previews, results, points table, fantasy tips, and cricket news only on BharatAbroad."
        />
        <meta
          name="keywords"
          content="India cricket score, IPL 2026 news, India vs match live, IPL live score today, Cricket match live India today, BCCI news updates, ICC rankings India players, Cricket highlights India match, Women's cricket India news, IPL auction 2026 news, IPL teams squad updates, IPL points table latest, IPL orange cap purple cap, IPL match highlights today, IPL playoff race updates, Domestic cricket India news, Ranji Trophy updates, Vijay Hazare Trophy news, Syed Mushtaq Ali Trophy updates, Under 19 cricket India news, India A team matches news, Women's IPL news India, Women's T20 league India updates, ICC tournament India news, Cricket World Cup India updates, Champions Trophy India news, Asia Cup India matches news, India vs Pakistan match news, India vs Australia cricket updates, India vs England series news, Cricket records India players, Fastest centuries India cricket, Cricket stats India players, Fantasy cricket tips India, Dream11 predictions India matches, India cricket schedule 2026, India upcoming matches cricket, India squad announcement news, Team India playing XI today, Cricket injury updates India players, Captaincy news India cricket, Test cricket India news, ODI cricket India updates, T20 cricket India news, Sports news India, BharatAbroad sports"
        />

        {/* Technical */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Sports News India | IPL 2026, Live Scores & Cricket Updates – BharatAbroad"
        />
        <meta
          property="og:description"
          content="Get the latest sports news in India with IPL 2026 updates, live cricket scores, match previews, results, points table, fantasy tips, and cricket news only on BharatAbroad."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.bharatabroad.com/sports" />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/BharatAbroad-Sports.png"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://www.bharatabroad.com/sports" />
      </Helmet>
      <Routes>
        {/* Main sports page shows maintenance
        <Route
          index
          element={
            <div
              style={{
                padding: "40px",
                textAlign: "center",
                minHeight: "70vh",
              }}
            >
              <h1>Sports Section Under Maintenance</h1>
              <p>
                We are working hard to bring you the latest sports updates.
                Please check back later!
              </p>
            </div>
          }
        /> */}
        {/* Individual sports pages */}
        <Route path="" element={<Cricket />} />
        <Route path="cricket" element={<Cricket />} />
        <Route path="nba" element={<NBA />} />
        <Route path="nfl" element={<NFL />} />
        <Route path="soccer" element={<Soccer />} />
        <Route path="golf" element={<Golf />} />
        <Route path="mlb" element={<MLB />} />
        <Route path="tennis" element={<Tennis />} />
        <Route path="hockey" element={<Hockey />} />
        <Route path="nhl" element={<NHL />} />
        <Route path="chess" element={<Chess />} />
        <Route path="olympics" element={<Olympics />} />
      </Routes>
    </div>
  );
}

export default Sports;
